<script setup>


const props = defineProps({
  data: Object
});

const trustPilotRoot = ref(null);
let observer = null;
let scriptEl = null;
let hasLoadedWidget = false;

const renderTrustPilot = () => {
  if (hasLoadedWidget) return;
  const trustbox = document.getElementById('trustbox');
  const target = trustbox?.children?.[0];
  if (!window.Trustpilot || !target) return;
  window?.Trustpilot?.loadFromElement(target);
  hasLoadedWidget = true;
};

const loadTrustPilotWidget = () => {
  if (window.Trustpilot) {
    renderTrustPilot();
    return;
  }

  scriptEl = document.querySelector('script[src*="widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"]');
  if (!scriptEl) {
    scriptEl = document.createElement('script');
    scriptEl.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    scriptEl.async = true;
    scriptEl.onload = () => {
      renderTrustPilot();
    };
    document.head.appendChild(scriptEl);
  } else {
    scriptEl.addEventListener('load', renderTrustPilot, { once: true });
  }
};

onMounted(() => {
  if (!('IntersectionObserver' in window)) {
    loadTrustPilotWidget();
    return;
  }

  observer = new IntersectionObserver((entries) => {
    if (!entries.some((entry) => entry.isIntersecting)) return;
    loadTrustPilotWidget();
    observer?.disconnect();
    observer = null;
  }, { rootMargin: '500px 0px' });

  if (trustPilotRoot.value) {
    observer.observe(trustPilotRoot.value);
  }
});

onBeforeUnmount(() => {
  observer?.disconnect();
  observer = null;
  scriptEl?.removeEventListener?.('load', renderTrustPilot);
});

</script>

<template>
  <div class="block trust-pilot" id="trust-pilot-reviews" ref="trustPilotRoot">
    <div class="container">
      <div class="row">
        <div class="col" v-html="data?.trustPilot?.script || ''" id="trustbox"></div>
      </div>
    </div>
  </div>
</template>